import { useCallback, useState } from 'react'

export function useFileUpload() {
  const [uploading, setUploading] = useState(false)
  const [files, setFiles] = useState<File[]>([])

  const handleFileChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.files && e.target.files.length > 0) {
        const incoming = Array.from(e.target.files)
        setFiles((prev) => {
          const fileKey = (f: File) =>
            `${f.name}:${f.size}:${f.lastModified}:${f.type}`
          const seen = new Set(prev.map(fileKey))
          const deduped = incoming.filter((f) => !seen.has(fileKey(f)))
          return [...prev, ...deduped]
        })
        e.target.value = ''
      }
    },
    []
  )

  return {
    uploading,
    setUploading,
    files,
    setFiles,
    handleFileChange
  }
}
